import { useState, useEffect } from 'react'
import { getTeamsExpandAPI } from '../services/teams'

function UseTeamsAll(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      searchs
    }
    const getData = async () => {
      const result = await getTeamsExpandAPI(param)
      if (!result) return

      const newData = result.result.map((d, i) => {
        return {
          value: d.team_id,
          label: d.team
        }
      })

      setData(newData)
    }
    if (orgId > 0) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseTeamsAll
